<!--
    Summary:
        hkml.exhibition.web - p3-y-dna-test3
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-p3-y-dna-test3" title="p3-y-dna-test3">
    <div class="title">
      {{$t('YDnaTest.p3_title')}}
    </div>
    <div class="content">
      <pre-p>{{$t('YDnaTest.p3_content')}}</pre-p>
      <pre-p>{{$t('YDnaTest.p3_content2')}}</pre-p>
      <pre-p>{{$t('YDnaTest.p3_content3')}}</pre-p>
      <pre-p>{{$t('YDnaTest.p3_content4')}}</pre-p>
      <pre-p>{{$t('YDnaTest.p3_content5')}}</pre-p>
    </div>
  </div>
</template>

<script>
  import PreP from "./pre-p";
  export default {
    name: "p3-y-dna-test3-en",
    components: {PreP}
  }
</script>


<style scoped lang="scss">
  .v-p3-y-dna-test3 {
    text-align: left;

    background: url("../../../assets/images/projects/y-dna-test/p3.jpg");
    background-size: 100% 100%;
    padding: 6vw 7vw 4.5vw 28vw;

    .title{
      // text-decoration: underline;
      font-size: 1.77vw;
      font-weight: bold;
      line-height: 3.13vw;
      color: #2f5eab;
      margin-bottom: 10px;
      margin-left:10px;
      position: relative;
    }
    .title:after{
      content:" ";
      position:absolute;
      left:0;
      bottom:0;
      width:50%;
      height:2px;
      transform:scaleY(1);
      background-color:#2f5eab;
    }
    .content{
      font-size: 1.77vw;
      color: #000000;
      margin-left:10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/p3-y-dna-test3-en.vue